import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openFilterPopup: {
		id: 'filter-refinement.search-field.keyboard-shortcuts.open-filter-popup',
		defaultMessage: 'Filter work items',
		description: 'Command in the command palette to open filter pop up',
	},
});
